import React, { useState, useEffect, useContext } from 'react';
import { MaterialReactTable } from 'material-react-table';
// eslint-disable-next-line import/no-extraneous-dependencies
import { useHistory } from 'react-router';
import { Modal, Box, Button } from '@mui/material';
import {
  getUsersQueriesOptionsActive,
  disableUserQueryOption,
  getClientUsersListForSchedulingScreen,
} from '../../services/usersQueriesOptions.api';
import {
  QueryOptionTypes,
  UserQueryOptionRunSourceTypes,
  TerritoryTypes,
} from '../../utils/constants/enums';
import { useAsync } from '../../utils/useAsync';
import { getReports } from '../../services/reportSelection.api';
import { actions, columns  } from './SavedQueryTable.utils';
import { useTableauQuery } from '../../contexts/TableauQuery';
import { routes as marketRoutes } from '../../utils/constants/market.routes';
import { routes as riskRoutes } from '../../utils/constants/risk.routes';
import { StoreContext } from '../../store/storeContext';
import { validateJsonAndGetTicket } from '../../components/tableauVizualization/queryValidation';
import { useToast } from '../../contexts/Toast';
import { TableIcons } from './TableIcons';
import ScheduleForm from '../scheduleQuery/ScheduleForm';
import DeleteSavedQueryModal from './deleteSavedQueryModal';
import BulkScheduleModal from './BulkScheduleModal';
import { getDataAccessClientsReportTypesActive } from '../../services/dataAccess.api';
import SelectReportToRun from '../../components/advancedQuery/components/selectReportToRun/SelectReportToRun';
import DeleteIcon from '@mui/icons-material/Delete';
import EventBusyIcon from '@mui/icons-material/EventBusy';
import EventAvailableIcon from '@mui/icons-material/EventAvailable';
import { disableUserScheduledQuery, addUserScheduledQuery, updateUserScheduledQuery, addUserScheduledQueryAdditionalActionSendNow } from '../../services/usersScheduledQueries.api';

function SavedQueryTable() {
  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 800,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
  };

  const [, setContextQuery] = useTableauQuery();
  const history = useHistory();
  const { setToastState } = useToast();
  const [reports, setReports] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [availableUsersQueriesOptionsActive, setAvailableUsersQueriesOptionsActive] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [currentRow, setCurrentRow] = useState({});
  const deleteMessage = `Delete ${currentRow.userQueryOptionNm}?`;
  const [clientType, setClientType] = React.useState(2);
  const [initializeEmails, setInitializeEmails] = React.useState([]);
  const [queryRebuildTemp, setQueryRebuildTemp] = React.useState({});

  const [reportSelectDictionary, setReportSelectDictionary] = useState([]);
  const [reportSelectArray, setReportSelectArray] = useState([]);
  const { actions: actionsContext } = useContext(StoreContext);
  const { run: runGetDataAccessClientsReportTypesActive } = useAsync();
  const [dataAccessClientsReportTypesActive, setDataAccessClientsReportTypesActive] = useState(0);
  const [openExecuterModal, setOpenExecuterModal] = useState(false);
  const handleCloseModal = () => setOpenExecuterModal(false);
  const [isSchedulerOperation, setIsSchedulerOperation] = useState(false);
  const [queryOptionTypeIdForSelectReportToRun, setQueryOptionTypeIdForSelectReportToRun] =
    useState();
  const [rowSelection, setRowSelection] = useState({});
  
  // State for bulk action confirmation modals
  const [showBulkDeleteModal, setShowBulkDeleteModal] = useState(false);
  const [showBulkUnscheduleModal, setShowBulkUnscheduleModal] = useState(false);
  const [showBulkScheduleModal, setShowBulkScheduleModal] = useState(false);
  const [bulkActionRows, setBulkActionRows] = useState([]);
  const [isBulkScheduleLoading, setIsBulkScheduleLoading] = useState(false);

  const runQuery = (query, queryOptionTypeId) => {
    setContextQuery(query);
    if (
      dataAccessClientsReportTypesActive === 1 &&
      queryOptionTypeId !== QueryOptionTypes.MarketAdvancedQuery
    ) {
      setToastState({
        open: true,
        severity: 'error',
        status: 401,
        message: 'Risk reports are no longer available with this licensing option.',
      });
    } else {
      history.push({
        pathname:
          queryOptionTypeId === QueryOptionTypes.MarketAdvancedQuery
            ? marketRoutes.reportDisplay.path
            : riskRoutes.reportDisplay.path,
      });
    }
  };

  const handleOpenModalOrRunQuery = (query, queryOptionTypeId, savedQueryJSONUnparsed) => {
    if (Object.keys(query?.chosenReports).length > 1) {
      setOpenExecuterModal(true);
      return;
    }
    if (Object.keys(query?.chosenReports).length === 1) {
      const reportId = Object.keys(query?.chosenReports)[0];
      if (
        savedQueryJSONUnparsed &&
        savedQueryJSONUnparsed !== '' &&
        query?.riskOptionsSelection?.riskDynamicFields
      ) {
        try {
          const riskDynamicFieldsForReportId =
            JSON.parse(savedQueryJSONUnparsed)?.riskOptionsSelection?.riskDynamicFields[reportId];
          /*
            v1 risk options or non risk option reports can't have more than 1 risk control.
          */
          if (riskDynamicFieldsForReportId === undefined) {
            runQuery(query, queryOptionTypeId);
          }
          const riskDynamicFieldsForReportControlName = Object.keys(
            riskDynamicFieldsForReportId,
          )[0];
          if (
            Object.values(riskDynamicFieldsForReportId[riskDynamicFieldsForReportControlName])
              .length > 1
          ) {
            setQueryOptionTypeIdForSelectReportToRun(queryOptionTypeId);
            setOpenExecuterModal(true);
            return;
          }
        } catch (err) {
          return;
        }
      }
      runQuery(query, queryOptionTypeId);
    }
  };

  // Helper function to construct the territory selection
  const constructTerritorySelection = (newQuery) => {
    if (
      newQuery?.territorySelection?.territoryTypes === undefined &&
      newQuery?.territorySelection?.states === undefined
    ) {
      return { territoryTypes: { 1: 1 }, states: {} };
    }
  
    if (newQuery?.territorySelection?.states === undefined) {
      const territoryTypesFullValue =
        newQuery?.territorySelection?.territoryTypes &&
        TerritoryTypes.Dealer in newQuery.territorySelection.territoryTypes
          ? { territoryTypes: { 2: 2 } }
          : { territoryTypes: { 1: 1 } };
  
      return { ...territoryTypesFullValue, states: {} };
    }
  
    const territoryTypesValueOnly =
      newQuery?.territorySelection?.territoryTypes &&
      TerritoryTypes.Dealer in newQuery.territorySelection.territoryTypes
        ? { 2: 2 }
        : { 1: 1 };
  
    return { ...newQuery.territorySelection, territoryTypes: territoryTypesValueOnly };
  };

    // Helper function to parse the response and construct the new query
    const parseResponse = (response, query, queryOptionTypeId) => {
      if (response.userQueryOptionStatusTypeId !== 1) {
        setToastState({
          open: true,
          severity: 'error',
          status: response.userQueryOptionStatusTypeId,
          message: response.userQueryOptionStatusAdditionalDetails,
        });
        if (response.userQueryOptionStatusTypeId !== 9) return null;
      }
    
      const newQuery = JSON.parse(response.userQueryOptionJSON);
      newQuery.reportingPeriods = {
        beginDateRange: [newQuery.reportingPeriods.beginDateRange],
        endDateRange: [newQuery.reportingPeriods.endDateRange],
        numOfMonths: newQuery.reportingPeriods.numOfMonths || 0, // Include numOfMonths with a fallback value
      };
      newQuery.chosenReports = query.chosenReports;
      newQuery.queryType = queryOptionTypeId;
      newQuery.queryName = query.queryName;
      newQuery.queryDescription = query.queryDescription;
      newQuery.userQueryOptionId = '';
    
      newQuery.territorySelection = constructTerritorySelection(newQuery);
    
      return newQuery;
    };

  // Helper function to navigate to the edit page
  const navigateToEditPage = (queryOptionTypeId) => {
    history.push({
      pathname:
        queryOptionTypeId === QueryOptionTypes.MarketAdvancedQuery
          ? marketRoutes.advancedQuery.path
          : riskRoutes.advancedQuery.path,
    });
  };

  const editQuery = async (query, queryOptionTypeId, finalAction = 'edit') => {
    try {
      const response = await validateJsonAndGetTicket(queryOptionTypeId, query, 'edit');
      const newQuery = parseResponse(response, query, queryOptionTypeId);
  
      if (!newQuery) return;
  
      window.localStorage.setItem(`${queryOptionTypeId}-aq`, JSON.stringify(newQuery));
  
      if (finalAction === 'edit') {
        navigateToEditPage(queryOptionTypeId);
      }
    } catch (e) {
      actions.errorAction(e);
    }
  };


  function getQueries() {
    getUsersQueriesOptionsActive()
      .then((availableUsersQueriesOptionsActiveData) => {
        setAvailableUsersQueriesOptionsActive(
          availableUsersQueriesOptionsActiveData.map((queryActive) => {
            const item = queryActive;
            if (!queryActive?.usersQueriesOptionsStateNms) {
              item.usersQueriesOptionsStateNms = 'All';
            }
            return item;
          }),
        );
        setIsLoading(false);

        const newReportSelectDictionary = [];
        const newReportSelectArray = [];

        availableUsersQueriesOptionsActiveData.forEach((item) => {
          newReportSelectDictionary.push({
            key: item.userQueryOptionId,
            value: 0,
          });
          newReportSelectArray.push(0);
        });

        setReportSelectDictionary(newReportSelectDictionary);
        setReportSelectArray(newReportSelectArray);
      })
      .catch((error) => {
        actionsContext.errorAction(error);
      });
  }

  useEffect(() => {
    getReports(import.meta.env.VITE_PRODUCTS_PRODUCT_ID_AUTOCOUNT_ACCELERATE).then(
      (getReportsData) => {
        setReports(getReportsData);
      },
    );
    getQueries();

    getClientUsersListForSchedulingScreen().then((availableUsersData) => {
      availableUsersData?.clientUsersList.forEach((item) => {
        // eslint-disable-next-line no-param-reassign
        item.userScheduledQueryEmailElementTypeId = 1;
      });
      setInitializeEmails(availableUsersData?.clientUsersList);
      setClientType(availableUsersData?.clientTypeId);
    });

    runGetDataAccessClientsReportTypesActive(
      getDataAccessClientsReportTypesActive().then((getDataAccessClientsReportTypesActiveData) => {
        if (
          getDataAccessClientsReportTypesActiveData !== undefined &&
          getDataAccessClientsReportTypesActiveData.length > 0
        ) {
          setDataAccessClientsReportTypesActive(
            getDataAccessClientsReportTypesActiveData[
              getDataAccessClientsReportTypesActiveData.length - 1
            ].reportTypeId,
          );
        } else {
          setDataAccessClientsReportTypesActive(0);
        }
      }),
    );
  }, []);

  function handleDisableUserQueryOptionButtonClick(rowData) {
    if (rowData?.userQueryOptionId !== undefined && rowData?.queryOptionTypeId !== undefined) {
      disableUserQueryOption(rowData?.userQueryOptionId, rowData?.queryOptionTypeId)
        .then(() => {
          getQueries();
        })
        .catch((error) => {
          actionsContext.errorAction(error);
        });
    }
  }

  // Show confirmation modal for bulk delete
  function handleBulkDeleteClick(table) {
    const selectedRows = table.getSelectedRowModel().rows;
    
    if (selectedRows.length === 0) {
      return;
    }

    // Store the rows to delete and show confirmation modal
    const rowsToDelete = selectedRows.map((row) => row.original);
    setBulkActionRows(rowsToDelete);
    setShowBulkDeleteModal(true);
  }

  // Execute bulk delete after confirmation
  function handleBulkDeleteConfirm() {
    // Call disableUserQueryOption for each selected row
    const deletePromises = bulkActionRows.map((row) => {
      if (row?.userQueryOptionId !== undefined && row?.queryOptionTypeId !== undefined) {
        return disableUserQueryOption(row.userQueryOptionId, row.queryOptionTypeId);
      }
      return Promise.resolve();
    });

    // Execute all delete operations
    Promise.all(deletePromises)
      .then(() => {
        // Clear selection after successful deletion
        setRowSelection({});
        // Hide modal and clear stored rows
        setShowBulkDeleteModal(false);
        setBulkActionRows([]);
        // Refresh the table
        getQueries();
      })
      .catch((error) => {
        actionsContext.errorAction(error);
        setShowBulkDeleteModal(false);
        setBulkActionRows([]);
      });
  }

  // Show confirmation modal for bulk unschedule
  function handleBulkUnscheduleClick(table) {
    const selectedRows = table.getSelectedRowModel().rows;
    
    if (selectedRows.length === 0) {
      return;
    }

    // Get the actual row data for selected rows that have a schedule
    const rowsToUnschedule = selectedRows
      .map((row) => row.original)
      .filter((row) => row?.userScheduledQueryId !== undefined && row?.userScheduledQueryId !== null);

    if (rowsToUnschedule.length === 0) {
      return;
    }

    // Store the rows to unschedule and show confirmation modal
    setBulkActionRows(rowsToUnschedule);
    setShowBulkUnscheduleModal(true);
  }

  // Execute bulk unschedule after confirmation
  function handleBulkUnscheduleConfirm() {
    // Call disableUserScheduledQuery for each selected row with a schedule
    const unschedulePromises = bulkActionRows.map((row) => {
      return disableUserScheduledQuery(row.userScheduledQueryId);
    });

    // Execute all unschedule operations
    Promise.all(unschedulePromises)
      .then(() => {
        // Update each row's schedule-related fields to null (to refresh the expanded schedule forms)
        setAvailableUsersQueriesOptionsActive((prevData) =>
          prevData.map((row) => {
            // Check if this row was unscheduled
            const wasUnscheduled = bulkActionRows.some(
              (unscheduledRow) => unscheduledRow.userQueryOptionId === row.userQueryOptionId
            );
            if (wasUnscheduled) {
              return {
                ...row,
                userScheduledQueryId: null,
                userScheduledQueryNm: null,
                userScheduledQueryFormatTypeId: null,
                userScheduledQueryFrequencyTypeId: null,
                userScheduledQueryDeliveryTypeId: null,
                userScheduledQueryCompressionTypeId: null,
              };
            }
            return row;
          })
        );
        
        // Clear selection after successful unscheduling
        setRowSelection({});
        // Hide modal and clear stored rows
        setShowBulkUnscheduleModal(false);
        setBulkActionRows([]);
        setIsSchedulerOperation(true);
        // Refresh the table
        getQueries();
      })
      .catch((error) => {
        actionsContext.errorAction(error);
        setShowBulkUnscheduleModal(false);
        setBulkActionRows([]);
      });
  }

  // Show confirmation modal for bulk schedule
  function handleBulkScheduleClick(table) {
    const selectedRows = table.getSelectedRowModel().rows;
    
    if (selectedRows.length === 0) {
      return;
    }

    // Get the actual row data for ALL selected rows (with or without schedule)
    const rowsToSchedule = selectedRows.map((row) => row.original);

    // Store the rows to schedule and show configuration modal
    setBulkActionRows(rowsToSchedule);
    setShowBulkScheduleModal(true);
  }

  // Execute bulk schedule after configuration
  function handleBulkScheduleConfirm(scheduleConfig, emailRecipients, runNow = false) {
    // Set loading state
    setIsBulkScheduleLoading(true);

    // Create schedule requests for each selected row
    const schedulePromises = bulkActionRows.map((row) => {
      const scheduledQueryRequest = [
        {
          ...scheduleConfig,
          userScheduledQueryNm: `${row.queryOptionTypeNm} ${row.userQueryOptionNm} Schedule`,
          userQueryOptionId: row.userQueryOptionId,
        },
      ];

      const usersScheduledQueriesEmailsRequest = emailRecipients;
      const scheduledQuerySTSRequest = [];

      // Check if row already has a schedule - if so, update it, otherwise add new
      if (row.userScheduledQueryId) {
        return updateUserScheduledQuery(
          row.userScheduledQueryId,
          scheduledQueryRequest,
          usersScheduledQueriesEmailsRequest,
          scheduledQuerySTSRequest
        );
      } else {
        return addUserScheduledQuery(
          scheduledQueryRequest,
          usersScheduledQueriesEmailsRequest,
          scheduledQuerySTSRequest
        );
      }
    });

    // Execute all schedule operations
    Promise.all(schedulePromises)
      .then((responses) => {
        // If runNow is true, execute all schedules immediately
        if (runNow) {
          const runNowPromises = responses.map((response) => {
            if (response?.usersScheduledQueriesResponse?.[0]?.userScheduledQueryId) {
              return addUserScheduledQueryAdditionalActionSendNow(
                response.usersScheduledQueriesResponse[0].userScheduledQueryId
              ).catch((error) => {
                // Catch individual run now errors without failing the whole operation
                console.error('Error running schedule immediately:', error);
                return { error: true, scheduleId: response.usersScheduledQueriesResponse[0].userScheduledQueryId };
              });
            }
            return Promise.resolve();
          });

          return Promise.all(runNowPromises).then((runNowResults) => {
            // Check if any run now operations failed
            const failedRunNow = runNowResults.filter(r => r?.error);
            return { responses, failedRunNow };
          });
        }
        return { responses, failedRunNow: [] };
      })
      .then(({ responses, failedRunNow }) => {
        // Update each row's schedule-related fields
        setAvailableUsersQueriesOptionsActive((prevData) =>
          prevData.map((row) => {
            // Find if this row was scheduled/updated
            const rowIndex = bulkActionRows.findIndex(
              (scheduledRow) => scheduledRow.userQueryOptionId === row.userQueryOptionId
            );
            if (rowIndex !== -1 && responses[rowIndex]?.usersScheduledQueriesResponse?.[0]) {
              const scheduleResponse = responses[rowIndex].usersScheduledQueriesResponse[0];
              return {
                ...row,
                userScheduledQueryId: scheduleResponse.userScheduledQueryId,
                userScheduledQueryNm: scheduleResponse.userScheduledQueryNm,
                userScheduledQueryFormatTypeId: scheduleResponse.userScheduledQueryFormatTypeId,
                userScheduledQueryFrequencyTypeId: scheduleResponse.userScheduledQueryFrequencyTypeId,
                userScheduledQueryDeliveryTypeId: scheduleResponse.userScheduledQueryDeliveryTypeId,
                userScheduledQueryCompressionTypeId: scheduleResponse.userScheduledQueryCompressionTypeId,
              };
            }
            return row;
          })
        );
        
        // Clear loading state
        setIsBulkScheduleLoading(false);
        
        // Clear selection after successful scheduling
        setRowSelection({});
        // Hide modal and clear stored rows
        setShowBulkScheduleModal(false);
        setBulkActionRows([]);
        setIsSchedulerOperation(true);
        
        // Count how many were updates vs new schedules
        const updatedCount = bulkActionRows.filter(row => row.userScheduledQueryId).length;
        const newCount = bulkActionRows.length - updatedCount;
        
        // Show success message
        let successMessage;
        if (runNow) {
          if (failedRunNow.length > 0) {
            successMessage = `Successfully scheduled ${bulkActionRows.length} report(s), but ${failedRunNow.length} failed to run immediately. The schedules have been created and will run on their next scheduled time.`;
          } else {
            successMessage = `Successfully scheduled and ran ${bulkActionRows.length} report(s).`;
          }
        } else {
          if (updatedCount > 0 && newCount > 0) {
            successMessage = `Successfully updated ${updatedCount} and created ${newCount} schedule(s).`;
          } else if (updatedCount > 0) {
            successMessage = `Successfully updated ${updatedCount} schedule(s).`;
          } else {
            successMessage = `Successfully created ${newCount} schedule(s).`;
          }
        }
        
        setToastState({
          open: true,
          severity: failedRunNow.length > 0 ? 'warning' : 'success',
          message: successMessage,
        });
        
        // Refresh the table
        getQueries();
      })
      .catch((error) => {
        // Clear loading state on error
        setIsBulkScheduleLoading(false);
        
        actionsContext.errorAction(error);
        setShowBulkScheduleModal(false);
        setBulkActionRows([]);
        
        setToastState({
          open: true,
          severity: 'error',
          message: 'Failed to schedule some reports. Please try again.',
        });
      });
  }

  function prepareAndRunQuery({
    reportIdSelectionIndex,
    userQueryOptionId,
    userQueryOptionNm,
    usersQueriesOptionsReportIds,
    savedQueryJSONUnparsed,
    queryOptionTypeId,
  }) {
    try {
      const usersQueriesOptionsReportIdsArray = usersQueriesOptionsReportIds.split(',');
      const queryRebuild = {};
      const reportId = parseInt(usersQueriesOptionsReportIdsArray[reportIdSelectionIndex]);
      const reportData = reports.find((item) => item.reportId === reportId);
      const newReportData = {
        [reportId]: {
          reportId,
          reportNm: reportData.reportNm,
          filterSheetNm: reportData.filterSheetNm,
          visualizationView: reportData.visualizationView,
          pdfView: reportData.pdfView,
          csvView: reportData.csvView,
          imageView: reportData.imageView,
          reportType: reportData.reportType
        },
      };
      queryRebuild.chosenReports = newReportData;
      queryRebuild.userQueryOptionRunSourceTypeId = UserQueryOptionRunSourceTypes.MyReports;

      queryRebuild.savedQueryId = userQueryOptionId;
      queryRebuild.queryName = userQueryOptionNm;

      queryRebuild.riskOptionsSelection = JSON.parse(savedQueryJSONUnparsed)?.riskOptionsSelection;
      setQueryRebuildTemp(queryRebuild);
      editQuery(queryRebuild, queryOptionTypeId, 'run');
      handleOpenModalOrRunQuery(queryRebuild, queryOptionTypeId, savedQueryJSONUnparsed);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log(error);
    }
  }

  function prepareAndEditQuery({
    userQueryOptionId,
    userQueryOptionNm,
    usersQueriesOptionsReportIds,
    queryOptionTypeId,
    userQueryOptionDesc,
  }) {
    try {
      const usersQueriesOptionsReportIdsArray = usersQueriesOptionsReportIds.split(',');
      const queryRebuild = {};
      queryRebuild.userQueryOptionRunSourceTypeId = UserQueryOptionRunSourceTypes.MyReports;
      const numberArray = usersQueriesOptionsReportIdsArray.map(Number);
      const reportData = reports.filter((item) => numberArray.indexOf(item.reportId) !== -1);
      queryRebuild.chosenReports = reportData.reduce((obj, item) => {
        // eslint-disable-next-line no-param-reassign
        obj[item.reportId] = item;
        return obj;
      }, {});

      queryRebuild.userQueryOptionRunSourceTypeId = UserQueryOptionRunSourceTypes.MyReports;

      queryRebuild.savedQueryId = userQueryOptionId;
      queryRebuild.queryName = userQueryOptionNm;
      queryRebuild.queryDescription = userQueryOptionDesc;

      editQuery(queryRebuild, queryOptionTypeId);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log(error);
    }
  }

  const LOCAL_STORAGE_KEY = 'savedQueryTablePageIndex';
  const getInitialPageIndex = () => {
    const stored = localStorage.getItem(LOCAL_STORAGE_KEY);
    const parsed = stored ? parseInt(stored, 10) : 0;
    return Number.isNaN(parsed) ? 0 : parsed;
  };
  const [pagination, setPagination] = useState({
    pageIndex: getInitialPageIndex(),
    pageSize: 10,
  });

  // Save pageIndex to localStorage on change
  useEffect(() => {
    localStorage.setItem(LOCAL_STORAGE_KEY, pagination.pageIndex);
  }, [pagination.pageIndex]);

  // Restore pageIndex after a full data reload
  useEffect(() => {
    setPagination((prev) => ({
      ...prev,
      pageIndex: getInitialPageIndex(),
    }));
  }, [availableUsersQueriesOptionsActive]);

  const updateRowData = (updatedRow) => {
    setAvailableUsersQueriesOptionsActive((prevData) =>
      prevData.map((row) =>
        row.userQueryOptionId === updatedRow.userQueryOptionId ? updatedRow : row
      )
    );
    setIsSchedulerOperation(true);
    
  };

  

  return (
    <div>
      <Modal
        open={openExecuterModal}
        onClose={handleCloseModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <SelectReportToRun
            // onChange={handleQueryOnChange}
            query={queryRebuildTemp}
            setContextQuery={setContextQuery}
            // reportPath={reportPath}
            caller="My Reports"
            queryOptionTypeId={queryOptionTypeIdForSelectReportToRun}
            callerRunQuery={runQuery}
          />
        </Box>
      </Modal>

      <MaterialReactTable
        enableRowSelection
        onRowSelectionChange={setRowSelection}
        renderTopToolbarCustomActions={({ table }) => {
          const selectedRows = table.getSelectedRowModel().rows;
          const selectedCount = selectedRows.length;
          // Count how many selected rows have a schedule
          const scheduledCount = selectedRows.filter(
            (row) => row.original?.userScheduledQueryId !== undefined && row.original?.userScheduledQueryId !== null
          ).length;
          
          return (
            <div style={{ display: 'flex', gap: '8px' }}>
              <Button
                variant="contained"
                color="success"
                onClick={() => handleBulkScheduleClick(table)}
                disabled={selectedCount === 0}
                startIcon={<EventAvailableIcon />}
              >
                Schedule Selected ({selectedCount})
              </Button>
              <Button
                variant="contained"
                color="warning"
                onClick={() => handleBulkUnscheduleClick(table)}
                disabled={scheduledCount === 0}
                startIcon={<EventBusyIcon />}
              >
                Unschedule Selected ({scheduledCount})
              </Button>
              <Button
                variant="contained"
                color="error"
                onClick={() => handleBulkDeleteClick(table)}
                disabled={selectedCount === 0}
                startIcon={<DeleteIcon />}
              >
                Delete Selected ({selectedCount})
              </Button>
            </div>
          );
        }}
        enableRowActions
        renderRowActions={({ row }) => (
          <div style={{ display: 'flex', gap: '8px' }}>
            {/* Row actions (Run, Edit, Delete) */}
            {actions(
              row,
              prepareAndRunQuery,
              prepareAndEditQuery,
              reportSelectDictionary,
              setShowModal,
              setCurrentRow,
            )}
          </div>
        )}

        enableExpanding // Enables expandable rows
        renderDetailPanel={({ row }) => (
        <ScheduleForm
          key={`schedule-${row.original.userQueryOptionId}-${row.original.userScheduledQueryId || 'none'}`}
          rowData={row.original}
          availableUsersQueriesOptionsActive={availableUsersQueriesOptionsActive}
          setAvailableUsersQueriesOptionsActive={setAvailableUsersQueriesOptionsActive}
          clientType={clientType}
          initializeEmails={initializeEmails}
          onScheduleSaved={updateRowData} // Pass the callback to refresh the table
        />
        )}

        columns={columns(
          reportSelectArray,
          reportSelectDictionary,
          setReportSelectArray,
          setReportSelectDictionary,
        )}
        
        data={availableUsersQueriesOptionsActive}
        
        state={{
          isLoading, // Pass the loading state
          pagination, // Pass the pagination state
          rowSelection, // Pass the row selection state
        }}
        
         onPaginationChange={(updater) => {
          setPagination((old) => {
            const newState = typeof updater === 'function' ? updater(old) : updater;

  
              if (
                isSchedulerOperation
              ) {

                newState.pageIndex = pagination.pageIndex;
                setIsSchedulerOperation(false);
              }
                localStorage.setItem(LOCAL_STORAGE_KEY, newState.pageIndex);
              
            
            return newState;
          });
        }}

        initialState={{
          pagination: { pageIndex: pagination.pageIndex, pageSize: pagination.pageSize },
        }}
        enablePagination
        
        enableColumnFilters
        
        muiTableBodyCellProps={{
          style: { fontSize: '15px' }, // Increase font size for body cells
        }}
        muiTableHeadCellProps={{
          style: { fontSize: '15px', fontWeight: 'bold' }, // Increase font size for header cells
        }}
        muiExpandButtonProps={({ row }) => ({
          children: <TableIcons.DetailPanel />, // Replace the default expand icon
          'aria-label': row.getIsExpanded() ? 'Collapse Schedule' : 'Expand Schedule', // Dynamic label
          title: row.getIsExpanded() ? 'Collapse Schedule' : 'Expand Schedule', // Dynamic tooltip
        })}
      />

      <DeleteSavedQueryModal
        title="Delete saved report"
        text={deleteMessage}
        show={showModal}
        onHideModal={() => {
          setShowModal(false);
        }}
        onConfirmAction={() => {
          handleDisableUserQueryOptionButtonClick(currentRow);
          setIsSchedulerOperation(true);
          setShowModal(false);/*  */
        }}
      />

      {/* Bulk Delete Confirmation Modal */}
      <DeleteSavedQueryModal
        title="Delete Multiple Saved Reports"
        text={`Are you sure you want to delete ${bulkActionRows.length} selected report(s)? This action cannot be undone.`}
        show={showBulkDeleteModal}
        onHideModal={() => {
          setShowBulkDeleteModal(false);
          setBulkActionRows([]);
        }}
        onConfirmAction={() => {
          handleBulkDeleteConfirm();
          setIsSchedulerOperation(true);
        }}
      />

      {/* Bulk Unschedule Confirmation Modal */}
      <DeleteSavedQueryModal
        title="Unschedule Multiple Reports"
        text={`Are you sure you want to unschedule ${bulkActionRows.length} selected report(s)?`}
        show={showBulkUnscheduleModal}
        onHideModal={() => {
          setShowBulkUnscheduleModal(false);
          setBulkActionRows([]);
        }}
        onConfirmAction={() => {
          handleBulkUnscheduleConfirm();
          setIsSchedulerOperation(true);
        }}
      />

      {/* Bulk Schedule Configuration Modal */}
      <BulkScheduleModal
        show={showBulkScheduleModal}
        onHideModal={() => {
          if (!isBulkScheduleLoading) {
            setShowBulkScheduleModal(false);
            setBulkActionRows([]);
          }
        }}
        onConfirmAction={(scheduleConfig, emailRecipients, runNow) => {
          handleBulkScheduleConfirm(scheduleConfig, emailRecipients, runNow);
          setIsSchedulerOperation(true);
        }}
        reportCount={bulkActionRows.length}
        initializeEmails={initializeEmails}
        isLoading={isBulkScheduleLoading}
      />
  </div>
  );
}

export default SavedQueryTable;
